import DOMPurify from 'dompurify'

// The minimum the backends send: menu-experience emits b/strong/br/span.highlight and the promo
// WYSIWYG emits p.lead/strong/span. Anything else is stripped, keeping its text.
const ALLOWED_TAGS = ['b', 'strong', 'em', 'i', 'br', 'p', 'span']
const ALLOWED_ATTR = ['class']

// https: or a same-site path; rejects javascript:, data:, http: and protocol-relative //host
const SAFE_LINK = /^(?:https:|\/(?!\/))/i

type SafeHtmlOptions = {
  allowLinks?: boolean
}

/**
 * The only way to build a `dangerouslySetInnerHTML` value; the `no-restricted-syntax` lint rule
 * rejects anything else.
 */
export const safeHtml = (html: string, { allowLinks = false }: SafeHtmlOptions = {}) => {
  // ponytail: no DOM on the server, so render nothing. Fine while no caller is server-rendered;
  // if one is, React 17 won't patch the innerHTML on hydrate - switch to isomorphic-dompurify.
  if (!html || !DOMPurify.isSupported) {
    return { __html: '' }
  }

  return {
    __html: DOMPurify.sanitize(html, {
      ALLOWED_TAGS: allowLinks ? [...ALLOWED_TAGS, 'a'] : ALLOWED_TAGS,
      ALLOWED_ATTR: allowLinks ? [...ALLOWED_ATTR, 'href'] : ALLOWED_ATTR,
      ALLOWED_URI_REGEXP: SAFE_LINK,
    }),
  }
}
